import React, { memo, useEffect, useState, useRef } from "react";
import { useCtx } from "@al/next/al-ex";
import dynamic from "@al/next/dynamic";

import useEvent from "~/components/hooks/useEvent";
import { tracker } from "~/common/tracker";

import securityVerifyEventBus from "./securityVerifyEventBus";

const SecurityVerificationMobile = dynamic(
  () => import(/* webpackChunkName: 'security-verification' */ "@al/security-verification-mobile")
);

interface SecurityVerificationSuccessResType {
  operationId: string;
}

const SecurityVerification = (): JSX.Element => {
  const ctx = useCtx();
  const [visibleVerification, setVisibleVerification] = useState(false);
  const extraPrams = useRef({});
  const [params, setParams] = useState({
    phoneNumber: "",
    deviceId: "",
  });

  useEffect(() => {
    const visibleFunc = async (params: any): Promise<void> => {
      setVisibleVerification(true);
      extraPrams.current = params;
      let deviceId = ctx.deviceId;
      if (!deviceId) {
        deviceId = await ctx.getDeviceId;
      }
      setParams({ phoneNumber: params.phoneNumber, deviceId });
    };
    securityVerifyEventBus.on("show", visibleFunc);
    return (): void => {
      securityVerifyEventBus.off("show", visibleFunc);
    };
  }, []);

  const onClose = useEvent(() => {
    setVisibleVerification(false);
  });

  const onRejected = useEvent((retry: boolean) => {
    // console.log("rejected", retry);
    securityVerifyEventBus.emit("rejected", retry);
  });

  const onSuccess = useEvent((result: SecurityVerificationSuccessResType) => {
    onClose();
    securityVerifyEventBus.emit("success", { riskFlowId: result.operationId, ...extraPrams.current });
  });

  const { countryId, languageId, languageCode } = ctx.locale;

  return (
    <SecurityVerificationMobile
      locale={languageCode}
      env={process.env.BUILD_ENV as "local" | "dev" | "test" | "prod"}
      visible={visibleVerification}
      deviceId={params.deviceId}
      countryId={countryId}
      languageId={languageId}
      hideInitialLoading
      bizType={219}
      saParams={{
        pageId: tracker.getPageConfig()?.sa?.page_id as string,
        pageName: tracker?.getPageConfig()?.sa?.page_name as string,
      }}
      phoneNumber={params.phoneNumber}
      onSuccess={onSuccess}
      onRejected={onRejected}
      onClose={onClose}
    />
  );
};

export default memo(SecurityVerification);
